{
  "logLevel": "critical",
  "apiSite": "https://wddsedev.prod.acquia-sites.com",
  "assetOrigin": "https://wddsedev.prod.acquia-sites.com", 
  "useMockAdapter": true,
  "mockDelayResponse": 0
}
